import BaseApiClient from '../BaseApiClient';
import { ListDataResponse } from '../types';
import { NotificationInterface } from '@interfaces/Notification.interface';

export class ApiNotification extends BaseApiClient {
  /**
   * Gets list of items
   */
  async list(
    page: number,
    perPage: number
  ): Promise<ListDataResponse<NotificationInterface>> {
    return new Promise((resolve, reject) => {
      this.client
        .get(`/notification?page=${page}&limit=${perPage}`)
        .then((res) => {
          if (res.data) {
            resolve({
              items: res.data.data,
              pagination: {
                page: res.data.meta?.current_page,
                perPage: res.data.meta?.per_page,
                total: res.data.meta?.total
              }
            });
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  /**
   * Get count
   */
  async count(): Promise<{ new: number }> {
    return new Promise((resolve, reject) => {
      this.client
        .get('/notification/count')
        .then((res) => {
          if (res.data) {
            resolve(res.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  /**
   * Get item
   */
  async get(id: string): Promise<NotificationInterface> {
    return new Promise((resolve, reject) => {
      this.client
        .get(`/notification/${id}`)
        .then((res) => {
          if (res.data) {
            resolve(res.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  /**
   * Get item
   */
  async delete(id: string): Promise<unknown> {
    return new Promise((resolve, reject) => {
      this.client
        .delete(`/notification/${id}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => reject(err));
    });
  }

  /**
   * Mark notification as read
   */
  async markRead(id: string): Promise<unknown> {
    return new Promise((resolve, reject) => {
      this.client
        .post(`/notification/${id}/read`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => reject(err));
    });
  }

  /**
   * Mark all notifications as read
   */
  async markAllRead(): Promise<unknown> {
    return new Promise((resolve, reject) => {
      this.client
        .post('/notification/read')
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => reject(err));
    });
  }
}

export { notificationQueryKeys } from './query-keys';
export type { NotificationListQueryParams } from './query-keys';
export {
  useNotificationCountQuery,
  useNotificationListQuery,
  useNotificationQuery
} from './use-notification-queries';
export {
  useNotificationDeleteMutation,
  useNotificationMarkAllReadMutation,
  useNotificationMarkReadMutation
} from './use-notification-mutations';
